const CEP_DIGIT_COUNT = 8

export const formatCep = (rawValue: string): string => {
  const digits = rawValue.replace(/\D/g, '').slice(0, CEP_DIGIT_COUNT)

  const [prefix, suffix] = [digits.slice(0, 5), digits.slice(5, 8)]

  return [prefix, suffix && `-${suffix}`].filter(Boolean).join('')
}
